import { Navigate } from "react-router-dom";
function ProtectedRoute({ isSignedIn, role, roleIn, children }: any) {
  if (!isSignedIn && role !== roleIn) {
    return <Navigate to="/" replace />;
  }
  return children;
}
export default ProtectedRoute;
